import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';

interface TypeConditionnement {
  id: number;
  libelle: string;
  articleIds?: number[];
}

@Component({
  selector: 'app-types-conditionnement',
  templateUrl: './types-conditionnement.component.html',
  styleUrls: ['./types-conditionnement.component.scss']
})
export class TypesConditionnementComponent implements OnInit {
  types: TypeConditionnement[] = [];
  typesFiltres: TypeConditionnement[] = [];
  recherche = '';
  chargement = false;
  sauvegardeEnCours = false;
  afficherModal = false;
  modeEdition = false;
  idEdition: number | null = null;

  formulaire: Partial<TypeConditionnement> = { libelle: '' };

  // Ce controller n'utilise pas /api/v1 mais /api directement
  private readonly apiUrl = `${environment.loginurl}type-conditionnements`;

  constructor(private http: HttpClient, private toast: ToastService) {}

  ngOnInit(): void { this.charger(); }

  charger(): void {
    this.chargement = true;
    this.http.get<TypeConditionnement[]>(this.apiUrl).subscribe({
      next: (data) => {
        this.types = Array.isArray(data) ? data : [];
        this.appliquerFiltre();
        this.chargement = false;
      },
      error: () => { this.chargement = false; this.toast.erreur('Impossible de charger les types de conditionnement'); }
    });
  }

  appliquerFiltre(): void {
    const q = this.recherche.toLowerCase().trim();
    this.typesFiltres = q ? this.types.filter(t => t.libelle.toLowerCase().includes(q)) : [...this.types];
  }

  ouvrirCreation(): void {
    this.modeEdition = false; this.idEdition = null;
    this.formulaire = { libelle: '' };
    this.afficherModal = true;
  }

  ouvrirEdition(t: TypeConditionnement): void {
    this.modeEdition = true; this.idEdition = t.id;
    this.formulaire = { libelle: t.libelle };
    this.afficherModal = true;
  }

  fermerModal(): void { this.afficherModal = false; }

  sauvegarder(): void {
    if (!this.formulaire.libelle?.trim()) { this.toast.erreur('Le libellé est obligatoire'); return; }
    this.sauvegardeEnCours = true;
    const req$ = this.modeEdition
      ? this.http.put<TypeConditionnement>(`${this.apiUrl}/${this.idEdition}`, this.formulaire)
      : this.http.post<TypeConditionnement>(this.apiUrl, this.formulaire);
    req$.subscribe({
      next: () => {
        this.toast.succes(this.modeEdition ? 'Type mis à jour' : 'Type créé');
        this.fermerModal(); this.charger(); this.sauvegardeEnCours = false;
      },
      error: () => { this.toast.erreur('Erreur lors de l\'enregistrement'); this.sauvegardeEnCours = false; }
    });
  }

  supprimer(t: TypeConditionnement): void {
    if (!confirm(`Supprimer le type "${t.libelle}" ?`)) return;
    this.http.delete(`${this.apiUrl}/${t.id}`).subscribe({
      next: () => { this.toast.succes('Type supprimé'); this.charger(); },
      error: () => this.toast.erreur('Impossible de supprimer ce type (peut-être utilisé par des articles)')
    });
  }

  nbArticles(t: TypeConditionnement): number { return t.articleIds?.length ?? 0; }
}
